"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@headlessui/react");
var classnames_1 = __importDefault(require("classnames"));
var react_2 = __importStar(require("react"));
function JetDropdown(_a) {
    var _b = _a.align, align = _b === void 0 ? 'right' : _b, _c = _a.width, width = _c === void 0 ? '48' : _c, _d = _a.contentClasses, contentClasses = _d === void 0 ? 'py-1 bg-white' : _d, renderTrigger = _a.renderTrigger, children = _a.children;
    var _e = (0, react_2.useState)(false), open = _e[0], setOpen = _e[1];
    var widthClass = {
        '48': 'w-48',
        '56': 'w-56',
        '60': 'w-60',
    }[width.toString()];
    var alignmentClasses = (function () {
        if (align === 'left') {
            return 'origin-top-left left-0';
        }
        else if (align === 'right') {
            return 'origin-top-right right-0';
        }
        else {
            return 'origin-top';
        }
    })();
    return (react_2.default.createElement("div", { className: "relative" },
        react_2.default.createElement("div", { onClick: function () { return setOpen(!open); } }, renderTrigger()),
        react_2.default.createElement("div", { className: "fixed inset-0 z-40", style: { display: open ? 'block' : 'none' }, onClick: function () { return setOpen(false); } }),
        react_2.default.createElement(react_1.Transition, { show: open, enter: "transition ease-out duration-200", enterFrom: "transform opacity-0 scale-95", enterTo: "transform opacity-100 scale-100", leave: "transition ease-in duration-75", leaveFrom: "transform opacity-100 scale-100", leaveTo: "transform opacity-0 scale-95" },
            react_2.default.createElement("div", { className: (0, classnames_1.default)('absolute z-50 mt-2 rounded-md shadow-lg', widthClass, alignmentClasses), onClick: function () { return setOpen(false); } },
                react_2.default.createElement("div", { className: (0, classnames_1.default)('rounded-md ring-1 ring-black ring-opacity-5', contentClasses) }, children)))));
}
exports.default = JetDropdown;
